import styles from './styles';

interface ListProps {
  options: Array<any>;
  className: string;
  onClick: any;
  ariaLabel: string;
  dataTestId: string;
  labelExtractor: (option: any) => string;
  valueExtractor: (option: any) => string;
  isSelected: (option: any) => boolean;
}

export default function List({
  options,
  className,
  onClick,
  ariaLabel,
  dataTestId,
  labelExtractor,
  valueExtractor,
  isSelected,
}: ListProps): JSX.Element {
  function handleKeyDown(event: React.KeyboardEvent, val: any): void {
    if (event.key === 'Enter' || event.key === ' ') {
      onClick(val);
    }
  }

  return (
    <>
      <ul role="listbox" className={className} aria-label={ariaLabel} data-testid={dataTestId}>
        {options.map((option, index) => {
          const label = labelExtractor(option);
          const value = valueExtractor(option);

          return (
            <li
              key={index}
              className={`list-item ${isSelected(option) ? 'selected' : ''}`}
              onClick={(): void => onClick(value)}
              onKeyDown={(event): void => handleKeyDown(event, value)}
              // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
              tabIndex={0}
              role="option"
              aria-selected={isSelected(option)}
            >
              {isSelected(option) && <div className="selected-icon" />}
              {label}
            </li>
          );
        })}
      </ul>
      <style>{styles}</style>
    </>
  );
}
